import CryptoJS from "crypto-js";
// import localStorageUtil from "@/utils/localStorageUtil";
import moment from "moment";

export const ACCESS_KEY = process.env.VUE_APP_X_CLIENT_ACCESS_KEY;
const SIGNATURE_KEY = process.env.VUE_APP_X_CLIENT_SIGNATURE_KEY;

export const makeSignatureKey = () => {
    // const UTC_TIME = localStorageUtil.getUTCTime();
    const momentUnix = moment().valueOf();
    // const date = moment(momentUnix + UTC_TIME).toDate();
    const date = moment(momentUnix).toDate();
    const utcDateString = `${date.getUTCFullYear()}-${zeroFill(date.getUTCMonth() + 1, 2)}-${zeroFill(date.getUTCDate(), 2)} ${zeroFill(date.getUTCHours(), 2)}:${zeroFill(date.getUTCMinutes(), 2)}`;
    const signBytes = CryptoJS.HmacSHA256(utcDateString, SIGNATURE_KEY);
    const signHex = CryptoJS.enc.Hex.stringify(signBytes);
    return signHex;
}

const zeroFill = (value, len) => "0".repeat(len - value.toString().length) + value;
